
export default (requests) => {
    return {
        getLiveMajorGames: () => {
            return requests.get(`/running/games/major`);
        },
    }
}